import { Dimensions } from 'react-native'

import { i18n } from '../localization'

export const DEVICE_WIDTH = Dimensions.get('window').width
export const DEVICE_HEIGHT = Dimensions.get('window').height
export const PROD_URL = 'https://api.zetapp.in/'

export const enum LeadStatus {
  LEAD_ADDED = 'leadadded',
  ACTION_REQUIRED = 'actnreqrd',
  PARTIALLY_FULLFILLED = 'pfulfilled',
  FULLFILLED = 'fullfilled',
  REJECTED = 'rejected',
  EXPIRED = 'expired',
  INCOMPLETE = 'saleIncomplete',
}

export const enum PaymentStatus {
  PENDING = 'pending',
  PAID = 'paid',
  REJECTED = 'rejected',
  FAILED = 'failed',
}

export const QuickFilter = {
  stage: {
    name: 'stage',
    value: [],
  },
  brands: {
    name: 'partner',
    value: [] as string[],
  },
  profileStatus: {
    name: 'status',
    value: [] as string[],
  },
  category: {
    name: 'category',
    value: [] as string[],
  },
}

export const playstoreRedirection =
  'http://play.google.com/store/apps/details?id=in.onecode.app'

export const appVideos = {
  zetMyNetwork: {
    title: ' ',
    videoId: 'CRsrSxdWLjg',
  },
  zetMyTeam: {
    title: ' ',
    videoId: 'CRsrSxdWLjg',
  },
  zetMyCustomers: {
    title: ' ',
    videoId: 'CRsrSxdWLjg',
  },
  zetWhyPan: {
    title: ' ',
    videoId: 'Q5PmwtJLUrs',
  },
  zetWhyOtp: {
    title: ' ',
    videoId: 'CRsrSxdWLjg',
  },
  zetHowToEarn: {
    title: ' ',
    videoId: 'kcvKVPUyrEY',
  },
  zetPlaceHolder: {
    title: ' ',
    videoId: 'CRsrSxdWLjg',
  },
  zetCreditScore: {
    title: ' ',
    videoId: 'uCq0WNrsjI8',
  },
}

export const Months = [
  {
    label: 'January',
    key: 0,
    value: 'january',
  },
  {
    label: 'February',
    key: 1,
    value: 'february',
  },
  {
    label: 'March',
    key: 2,
    value: 'march',
  },
  {
    label: 'April',
    key: 3,
    value: 'april',
  },
  {
    label: 'May',
    key: 4,
    value: 'may',
  },
  {
    label: 'June',
    key: 5,
    value: 'june',
  },
  {
    label: 'July',
    key: 6,
    value: 'july',
  },
  {
    label: 'August',
    key: 7,
    value: 'august',
  },
  {
    label: 'September',
    key: 8,
    value: 'september',
  },
  {
    label: 'October',
    key: 9,
    value: 'october',
  },
  {
    label: 'November',
    key: 10,
    value: 'november',
  },
  {
    label: 'December',
    key: 11,
    value: 'december',
  },
]
export const rejectionPayoutCategoryList = ['9', '15', '10', '11', 'all']

export const loansCategoriesEmiCalculator = ['11', '9', '10', '12']

export const filterData = [
  {
    icon: '',
    text: 'ZET Id',
    key: 'ZET_ID',
  },
  {
    icon: '',
    text: 'Phone Number',
    key: 'PHONE_NUMBER',
  },
  {
    icon: '',
    text: 'Name',
    key: 'NAME',
  },
]

export const sortingOptionsForVerified = [
  {
    label: i18n.t('myCustomers.byCreditScore'),
    value: 'creditReport',
  },
  {
    label: i18n.t('myCustomers.byName'),
    value: 'name',
  },
  {
    label: i18n.t('myCustomers.byAdditonDate'),
    value: 'createdAt',
  },
]

export const sortingOptionsForNonVerified = [
  {
    label: i18n.t('myCustomers.byAdditonDate'),
    value: 'createdAt',
  },
  {
    label: i18n.t('myCustomers.byName'),
    value: 'name',
  },
]

export const bannerLogic = {
  COLLAPSIBLE_ON_CLICK: 'COLLAPSIBLE_ON_CLICK',
}

export const CATEGORIES_MAPPING = {
  CREDIT_CARDS: 15,
  PERSONAL_LOANS: 9,
  INSTANT_LOANS: 9,
  BNPL: 16,
  BUSINESS_LOANS: 10,
  GOLD_LOAN: 12,
  BANK_ACCOUNTS: 5,
  SECURED_CREDIT_CARD: 18,
  EMI_CARD: 16,
}

export const myTeamEarningsFaqs = [
  {
    question: i18n.t('myTeamEarningsFaqs.question1'),
    answer: [i18n.t('myTeamEarningsFaqs.answer1')],
  },
  {
    question: i18n.t('myTeamEarningsFaqs.question2'),
    answer: [i18n.t('myTeamEarningsFaqs.answer2WithFee')],
  },
  {
    question: i18n.t('myTeamEarningsFaqs.question3'),
    answer: [i18n.t('myTeamEarningsFaqs.answer3')],
  },
  {
    question: i18n.t('myTeamEarningsFaqs.question4'),
    answer: [i18n.t('myTeamEarningsFaqs.answer4')],
  },
  {
    question: i18n.t('myTeamEarningsFaqs.question5'),
    answer: [i18n.t('myTeamEarningsFaqs.answer5')],
  },
  {
    question: i18n.t('myTeamEarningsFaqs.question6'),
    answer: [i18n.t('myTeamEarningsFaqs.answer6')],
  },
]

export const enum AndroidUpdateType {
  FLEXIBLE = 0,
  IMMEDIATE = 1,
}

export enum AndroidAvailabilityStatus {
  UNKNOWN = 0,
  AVAILABLE = 2,
  UNAVAILABLE = 1,
  DEVELOPER_TRIGGERED = 3,
}
